import { jsx as l } from "react/jsx-runtime";
const s = ({ className: o, width: r = "24", height: t = "24" }) => /* @__PURE__ */ l(
  "svg",
  {
    className: o,
    width: r,
    height: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ l(
      "path",
      {
        d: "M18.258 10.85c.55-.002.993.441.99.99-.003.55-.45.998-1 1l-5.15.042-.043 5.366c-.003.55-.45.997-1 1a.983.983 0 0 1-.99-.99l.043-5.366-5.366.043a.983.983 0 0 1-.99-.99c.003-.549.45-.997 1-1l5.366-.042.042-5.151c.002-.55.45-.997 1-1 .549-.003.992.44.99.99l-.042 5.15 5.15-.041Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  s as default
};
